// Copyright © 2021 Move Closer
export const SetupServiceType = Symbol.for('ISetupService');
